var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoodenSpoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    width: 50,
    id: "spoon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#dbba56;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,27c0,0.3,0.1,0.5,0.3,0.7c0.4,0.4,1,0.4,1.4,0l8.6-10.1L4.2,26.3C4.1,26.5,4,26.7,4,27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,3.9c-1.8,0.2-3.6,1-4.9,2.3c-2.1,2.1-2.8,5.1-1.9,7.9l0.1,0.2l0.2,0.1c2.8,0.9,5.8,0.2,7.9-1.9 c1.4-1.3,2.2-3.1,2.2-5c0-1-0.3-1.9-1-2.6C26.2,4.2,25.2,3.8,24.3,3.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3,2c-2.3,0.2-4.5,1.2-6.2,2.8c-2.4,2.4-3.4,5.9-2.6,9.2L2.9,24.9C2.3,25.4,2,26.2,2,27s0.3,1.6,0.9,2.1 C3.4,29.7,4.2,30,5,30s1.6-0.3,2.2-0.9L18,16.5c0.8,0.2,1.5,0.3,2.3,0.3c2.5,0,5-1,6.9-2.9c1.7-1.7,2.7-3.9,2.8-6.2 c0.1-1.5-0.5-3-1.6-4.1C27.3,2.5,25.8,1.9,24.3,2z M5.7,27.7c-0.4,0.4-1,0.4-1.4,0C4.1,27.5,4,27.3,4,27s0.1-0.5,0.2-0.7l10.1-8.7 L5.7,27.7z M25.7,12.5c-2.1,2.1-5.1,2.8-7.9,1.9l-0.2-0.1l-0.1-0.2c-0.9-2.8-0.2-5.8,1.9-7.9c1.3-1.3,3.1-2.1,4.9-2.3 c0.9-0.1,1.9,0.3,2.6,1c0.7,0.7,1,1.6,1,2.6C27.9,9.4,27.1,11.2,25.7,12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodenSpoon);
export default __webpack_public_path__ + "static/media/woodenSpoon.d70de2d1dd95306543dce962f3df0817.svg";
export { ForwardRef as ReactComponent };